import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "../config";
import {
  IApiCustomerResponse,
  IApiLoopingResponse,
  IApiLoopingSummaryResponse,
  IApiPayrollAllResponse,
  IApiPayrollGenerateResponse,
  IApiPayrollResponse,
  IApiResponse,
  IApiResponseDhashboard,
  IApiResponseForPunch,
  IApiResponsePunchDashboard,
  IApiTenantResponse,
  ICategoryFilterPayload,
  ICategoryPayload,
  ICustomerTransactionPayload,
  IDayAnEmpEachRecordPayload,
  IDayEmpReportPayload,
  IEmployeePunchImgPayload,
  IEmployeeScheduleDetailsPayload,
  IGetByCategoryArrayPayload,
  IGetByCategoryPayload,
  IGetRent,
  ILoopingTableListPayload,
  IPayrollAnEmpPayload,
  IPayrollAnEmpPayloadSec,
  IPayrollListApiResponse,
  IPayrollPayload,
  IPayrollPayloadWeeklyReport,
  IPerentFilterPayload,
  IPolicyCustomerIdPayload,
  IPolicyNumberPayload,
  IPolicyPayload,
  IPolicyTermsPayload,
  IProductPayload,
  IReSchedulPayload,
  IRelationPayload,
  ISavePayrollAnEmpEachRecordPayload,
  ISavePayrollAnEmpPayload,
  ISearchIsActivePayload,
  ISearchPayload,
  ISumaryReportListPayload,
  ITeamListPayload,
  ITenatListPayload,
  IUser,
  PrivilegesResponse,
  IMeetingPayload,
  IPolicyFilterAllPayload,
  IMeetingApiResponse,
  ILoopingTableListPayload2,
  IApiResponseDelateClient,
  IMeetingPayload2,
  IIdOnlyPayload,
  IApiResponseDhashbordClient,
  IsearchTextPayload,
  IHolidayApiResponse,
  IHolidayTitleApiResponse,
  ICountApiResponse,
  IEmailRecordPayload,
  INewletterCutomerFilterPayload,
  IPerentFilterTablePayload,
  ITasksPayload,
  ILastUpdateSummaryApiResponse,
  IgetLastUpdatedRemarkPayload,
  IMultiClientSummayReport,
  DownloadPdfResponse,
  IApiBirthdayResponse,
} from "./Interface/api.interface";
/**
 * Holds all the API callbacks
 * @returns RTK Implementation for backend
 */

export const attoDeskApi = createApi({
  reducerPath: "attoDeskApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set(
        "Authorization",
        `Bearer ${localStorage.getItem("token") || ""}`
      );
      return headers;
    },
  }),
  tagTypes: [
    "User",
    "category",
    "company",
    "department",
    "coursing",
    "tax",
    "product",
    "printer",
    "productBrand",
    "productTag",
    "productCategory",
    "modifier",
    "productGetByCategory",
    "looping",
    "customer",
    "ThemeColor",
    "Policy",
    "PolicySummaryReport",
    "PolicyView",
    "summaryReportPdf",
    "PunchDetails",
    "EmployeeSchedule",
    "Position",
    "Payroll",
    "Reschedule",
    "branch",
    "themeColor",
    "team",
    "dashboard",
    "UserRole",
    "Setting",
    "Privilege",
    "Meeting",
    "Conversations",
    "email",
    "newsletter",
    "client_type",
    "Task",
    "Workshop",
  ],
  endpoints: (builder) => ({
    getUser: builder.query<IApiResponse, void>({
      query: (request) => {
        return {
          url: "/user/userInfo",
          method: "POST",
          body: request,
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["User"],
    }),
    login: builder.mutation<IApiResponse, IUser>({
      query: (request) => {
        return {
          url: "/login",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
    }),
    createCategory: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/category",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["category", "productCategory"],
    }),
    createCompany: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/company",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["company"],
    }),
    createDepartment: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/department",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["department"],
    }),
    createCoursing: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/coursing",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["coursing"],
    }),
    createTax: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/tax",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["tax", "product", "category"],
    }),
    createProductBrand: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/product/brand",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productBrand", "product"],
    }),
    createProductTag: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/product/tags",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productTag", "product"],
    }),
    createProductCategory: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/product/category",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productCategory", "product"],
    }),
    createProduct: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/product",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["product"],
    }),
    createPrinter: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/printer",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["printer", "product"],
    }),
    getCategory: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/category/getAll",
          method: "POST",
        };
      },
      providesTags: ["product", "category"],
      keepUnusedDataFor: 0,
    }),
    getAllMainCategory: builder.query<IApiResponse, ICategoryPayload>({
      query: (request) => {
        return {
          url: "/main-category/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["product", "category"],
      keepUnusedDataFor: 0,
    }),
    deleteCoursing: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/coursing/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["coursing"],
    }),
    deleteDepartment: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/department/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["department"],
    }),
    deletePrinter: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/printer/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["printer"],
    }),
    deleteProductBrand: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/product/brand/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["productBrand"],
    }),
    deleteProductTag: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/product/tags/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["productTag"],
    }),
    deleteTax: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/tax/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["tax"],
    }),
    deleteProductCategory: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/product/category/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["productCategory"],
    }),
    deleteCategory: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/category/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["category", "productCategory"],
    }),
    getProduct: builder.query<IApiResponse, IProductPayload>({
      query: (request) => {
        return {
          url: "/product/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productTag", "product"],
      keepUnusedDataFor: 0,
    }),
    createGetAllProduct: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/product/getAll",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["productTag", "product"],
    }),
    deleteProduct: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/product/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["product"],
    }),
    getLastProductId: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/product/last-id",
          method: "GET",
        };
      },
      providesTags: ["product"],
      keepUnusedDataFor: 0,
    }),
    createModifier: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/modifier",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["modifier"],
    }),
    getAllModifier: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/modifier/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["modifier"],
      keepUnusedDataFor: 0,
    }),
    deleteModifier: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/modifier/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["modifier"],
    }),
    getDepartment: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/department/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["department", "category"],
      keepUnusedDataFor: 0,
    }),
    getTax: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/tax/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["tax", "category", "product"],
      keepUnusedDataFor: 0,
    }),
    getCoursing: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/coursing/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["coursing", "category"],
      keepUnusedDataFor: 0,
    }),
    getPrinter: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/printer/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["printer", "product"],
      keepUnusedDataFor: 0,
    }),
    getProductTag: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: "/product/tags/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productTag", "product"],
      keepUnusedDataFor: 0,
    }),
    getProductBrand: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: "/product/brand/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productBrand", "product"],
      keepUnusedDataFor: 0,
    }),
    getProductCategory: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: "/product/category/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productCategory", "product"],
      keepUnusedDataFor: 0,
    }),
    // getSubCategoryByCategoryId: builder.query<IApiResponse, ISearchIsActivePayload>({
    //   query: (request) => {
    //     return {
    //       url: '/product/category/getAll',
    //       method: "POST",
    //       body: request,
    //     };
    //   },
    //   providesTags:['productCategory','product'],
    //   keepUnusedDataFor: 0,
    // }),
    getSubCategoryByCategoryId: builder.query<
      IApiResponse,
      IGetByCategoryPayload
    >({
      query: (request) => {
        return {
          url: "/product/get-by-categories",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productGetByCategory", "product"],
      keepUnusedDataFor: 0,
    }),
    getSubCategoryByArray: builder.query<
      IApiResponse,
      IGetByCategoryArrayPayload
    >({
      query: (request) => {
        return {
          url: "/category/category-fiter/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productGetByCategory", "product", "productCategory"],
      keepUnusedDataFor: 0,
    }),
    getProductSubCategory: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: "/category/sub-category/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["productCategory", "product"],
      keepUnusedDataFor: 0,
    }),
    getAllCategoryName: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/all-category/getAll",
          method: "POST",
        };
      },
      providesTags: ["productCategory"],
      keepUnusedDataFor: 0,
    }),
    getCtegoryFilter: builder.query<IApiResponse, ICategoryFilterPayload>({
      query: (request) => {
        return {
          url: "/category/filter",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["product"],
      keepUnusedDataFor: 0,
    }),
    getLoopingTable: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/looping/list-tables",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["category", "product", "looping"],
      keepUnusedDataFor: 0,
    }),
    createLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/looping/create-table",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["looping", "product"],
    }),
    getAllLoopingTable: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/looping/list-tables",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["looping", "product"],
      keepUnusedDataFor: 0,
    }),
    deleteLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/looping/delete-table",
          method: "DELETE",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["looping", "product"],
    }),
    updateLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/looping/update-table",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["looping", "product"],
    }),
    insertOrUpdateDataLoopingTable: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/looping/table/insert-update-data",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["product", "looping"],
    }),
    getCustomer: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/customer/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy"],
      keepUnusedDataFor: 0,
    }),
    getLimitOneCustomer: builder.query<IApiResponse, ILoopingTableListPayload2>(
      {
        query: (request) => {
          return {
            url: "/customer/limit-one",
            method: "POST",
            body: request,
          };
        },
        providesTags: ["Policy", "customer"],
        keepUnusedDataFor: 0,
      }
    ),
    deleteCustomer: builder.mutation<IApiResponseDelateClient, string>({
      query: (Id) => {
        return {
          url: `/customer/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["customer"],
    }),
    createCustomer: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/customer",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["customer"],
    }),
    getCustomerTransaction: builder.query<
      IApiResponse,
      ICustomerTransactionPayload
    >({
      query: (request) => {
        return {
          url: "/customer/transaction/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer"],
      keepUnusedDataFor: 0,
    }),
    deleteCustomerTransaction: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/customer/transaction/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["customer"],
    }),
    createCustomerTransaction: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/customer/transaction",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["customer"],
    }),
    getCompany: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/company/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["company"],
      keepUnusedDataFor: 0,
    }),
    deleteCompany: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/company/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["company"],
    }),
    getAllSearchCompany: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/company/search/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["company"],
      keepUnusedDataFor: 0,
    }),
    createThemeColor: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/theme/color",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["ThemeColor"],
    }),
    getAllThemeColor: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/theme/color/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["ThemeColor"],
      keepUnusedDataFor: 0,
    }),
    createPolicy: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/policy",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Policy", "customer"],
    }),
    getAllPolicy: builder.query<IApiResponse, IPolicyPayload>({
      query: (request) => {
        return {
          url: "/policy/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer"],
      keepUnusedDataFor: 0,
    }),
    createPolicyTerms: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/policy-terms",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["product"],
    }),
    getAllPolicyTerms: builder.query<IApiResponse, IPolicyTermsPayload>({
      query: (request) => {
        return {
          url: "/policy-terms/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["product"],
      keepUnusedDataFor: 0,
    }),
    getAllPolicyCustomerId: builder.query<
      IApiResponse,
      IPolicyCustomerIdPayload
    >({
      query: (request) => {
        return {
          url: "/policy/getAll/customerId",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer"],
      keepUnusedDataFor: 0,
    }),
    createPolicySummaryReport: builder.mutation<
      IApiLoopingSummaryResponse,
      Object
    >({
      query: (request) => {
        return {
          url: "/policy-summary/report",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PolicySummaryReport"],
    }),
    createPolicySummaryDescription: builder.mutation<
      IApiLoopingSummaryResponse,
      Object
    >({
      query: (request) => {
        return {
          url: "/policy-summary/report/discription",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PolicySummaryReport"],
    }),
    createPolicySummaryRemark: builder.mutation<
      IApiLoopingSummaryResponse,
      Object
    >({
      query: (request) => {
        return {
          url: "/policy-summary/report/remark",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PolicySummaryReport"],
    }),
    getAllByPolicyNumber: builder.query<IApiResponse, IPolicyNumberPayload>({
      query: (request) => {
        return {
          url: "/policy/number/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer", "PolicyView"],
      keepUnusedDataFor: 0,
    }),
    getAllPolicyGroupBy: builder.query<IApiResponse, IPolicyPayload>({
      query: (request) => {
        return {
          url: "/policy/number/group-by/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer"],
      keepUnusedDataFor: 0,
    }),
    getAllPolicyGroupByEmpty: builder.query<IApiResponse, IPolicyPayload>({
      query: (request) => {
        return {
          url: "/policy/number/group-by/getOne",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer"],
      keepUnusedDataFor: 0,
    }),
    createCoveragePolicyTermsContion: builder.mutation<
      IApiLoopingResponse,
      Object
    >({
      query: (request) => {
        return {
          url: "/policy/coverage/term/terms-condition",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PolicyView"],
    }),
    createSumaryReportPolicyTerms: builder.mutation<
      IApiLoopingResponse,
      Object
    >({
      query: (request) => {
        return {
          url: "/policy/coverage/term/summay-report",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PolicyView"],
    }),
    createOfficeUse: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/policy/office-use",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PolicyView"],
    }),
    deletePolicyTerms: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/policy/terms/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["product"],
    }),
    getFinalSummaryReport: builder.query<
      IApiResponse,
      ISumaryReportListPayload
    >({
      query: (request) => {
        return {
          url: "/policy-summary/report/pdf",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["summaryReportPdf"],
      keepUnusedDataFor: 0,
    }),
    deleteBasicsPolicy: builder.mutation<IApiResponse, string>({
      query: (policyNumber) => {
        return {
          url: `/basics-policy/${policyNumber}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["customer"],
    }),
    createPolicyBasics: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/policy/basics/update",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Policy", "customer"],
    }),
    deletePolicy: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/policy/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Policy"],
    }),
    getCustomerFilterByPerent: builder.query<
      IApiResponse,
      IPerentFilterPayload
    >({
      query: (request) => {
        return {
          url: "/customer/getAll/filter/perent",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy"],
      keepUnusedDataFor: 0,
    }),
    getCustomerRelation: builder.query<IApiResponse, IRelationPayload>({
      query: (request) => {
        return {
          url: "/policy-summary/relations",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy"],
      keepUnusedDataFor: 0,
    }),

    // ------------------------------ staff management Api ---------------------

    createLightThemeColorOder: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/light/theme/color/order",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["themeColor"],
    }),
    createDarkThemeColorOrder: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/dark/theme/color/order",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["themeColor"],
    }),
    createTeam: builder.mutation<IApiTenantResponse, Object>({
      query: (request) => {
        return {
          url: "/team",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["team"],
    }),
    getTeam: builder.query<IApiResponse, ITeamListPayload>({
      query: (request) => {
        return {
          url: "/team/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    deleteTeam: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/team/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["team"],
    }),
    getPunchDetails: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/punch/details/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getPunchDashboard: builder.query<IApiResponsePunchDashboard, void>({
      query: (request) => {
        return {
          url: "/dashboard/punch/details",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    deleteEmployeeSchedule: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/employee/schedule/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["team"],
    }),
    getEmployeeScheduleDetails: builder.query<
      IApiResponse,
      IEmployeeScheduleDetailsPayload
    >({
      query: (request) => {
        return {
          url: "/employee/schedule/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getEmployeeScheduleDetailsByDate: builder.query<
      IApiResponse,
      IEmployeeScheduleDetailsPayload
    >({
      query: (request) => {
        return {
          url: "/employee/schedule/date/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    getEmployeeImg: builder.query<
      IApiResponseForPunch,
      IEmployeePunchImgPayload
    >({
      query: (request) => {
        return {
          url: "/punch/details/get-img",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    createPosition: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/position",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Position"],
    }),
    deletePosition: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/position/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Position"],
    }),
    getPosition: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/position/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Position"],
      keepUnusedDataFor: 0,
    }),
    getEmployeePayRoll: builder.query<IApiPayrollResponse, IPayrollPayload>({
      query: (request) => {
        return {
          url: "/team/payroll/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    createAdminEditPunch: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/punch/details/admin/edit",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PunchDetails"],
    }),

    getEmployeePayRollAdmin: builder.query<
      IApiPayrollResponse,
      IPayrollPayload
    >({
      query: (request) => {
        return {
          url: "/punch/record/payroll-generate",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getlastUpdateDatePayroll: builder.query<IApiPayrollResponse, void>({
      query: (request) => {
        return {
          url: "/last-update/payroll-date",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    createReschedule: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/emp/schedule/record",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Reschedule"],
    }),
    deleteReschedule: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/emp/schedule/record/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Reschedule"],
    }),
    getReschedule: builder.query<IApiResponse, IReSchedulPayload>({
      query: (request) => {
        return {
          url: "/emp/schedule/record/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Reschedule"],
      keepUnusedDataFor: 0,
    }),
    getTeamSerchOnly: builder.query<IApiResponse, ITeamListPayload>({
      query: (request) => {
        return {
          url: "/team/search/only",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    getEmployeeScheduleDetailsByDateOnly: builder.query<
      IApiResponse,
      IEmployeeScheduleDetailsPayload
    >({
      query: (request) => {
        return {
          url: "/employee/schedule/date/only",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    removedReschedule: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/emp/schedule/record/removed",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Reschedule"],
    }),
    getRescheduleOrderByDate: builder.query<IApiResponse, IReSchedulPayload>({
      query: (request) => {
        return {
          url: "/emp/schedule/record/getAll/orderBy/Date",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Reschedule"],
      keepUnusedDataFor: 0,
    }),
    getEmployeePayRollAdminUse: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/payroll/generate",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Payroll"],
    }),
    getAnEmployeePayRollAdmin: builder.query<
      IApiPayrollResponse,
      IPayrollAnEmpPayloadSec
    >({
      query: (request) => {
        return {
          url: "/punch/record/employee/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getAllPayrollList: builder.query<IApiResponse, void>({
      query: () => {
        return {
          url: "/payroll/list/getAll",
          method: "POST",
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getAllPayrollRecordeDateRange: builder.query<IApiPayrollAllResponse, void>({
      query: (request) => {
        return {
          url: "/payroll/record/date-range/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getSaveEmployeePayrollRecord: builder.query<
      IPayrollListApiResponse,
      IEmployeePunchImgPayload
    >({
      query: (request) => {
        return {
          url: "/save/payroll/List/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    getSaveAnEmployeePayRollAdmin: builder.query<
      IApiPayrollResponse,
      ISavePayrollAnEmpPayload
    >({
      query: (request) => {
        return {
          url: "/save/punch/record/employee/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getSaveAnEmplEachRecordPayRollAdmin: builder.query<
      IApiPayrollResponse,
      ISavePayrollAnEmpEachRecordPayload
    >({
      query: (request) => {
        return {
          url: "/save/punch/record/employee/each",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getPunchDetailsEmp: builder.query<IApiResponse, IPayrollAnEmpPayload>({
      query: (request) => {
        return {
          url: "/punch/details/getEmp",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    getSaveEmployeePayrollAnEmployeeRecord: builder.query<
      IApiResponse,
      IPayrollAnEmpPayload
    >({
      query: (request) => {
        return {
          url: "/save/payroll/List/emp",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["team"],
      keepUnusedDataFor: 0,
    }),
    PayrollRecordeEmp: builder.query<
      IApiPayrollAllResponse,
      IPayrollAnEmpPayloadSec
    >({
      query: (request) => {
        return {
          url: "/payroll/list/emp",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll", "team"],
      keepUnusedDataFor: 0,
    }),
    EditEmployeePayRollAdmin: builder.query<IApiPayrollResponse, IGetRent>({
      query: (request) => {
        return {
          url: "/punch/record/edit/payroll-generate",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    getDayRecordAnEmplEachRecord: builder.query<
      IApiPayrollResponse,
      IDayAnEmpEachRecordPayload
    >({
      query: (request) => {
        return {
          url: "/punch/record/employee/day/each",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    empPayrollPayrollRecordReport: builder.query<
      IApiPayrollResponse,
      IDayEmpReportPayload
    >({
      query: (request) => {
        return {
          url: "/save/payroll/List/emp/day-by-day/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Payroll"],
      keepUnusedDataFor: 0,
    }),
    editPunchInTime: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/punch/edit/punch-in",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PunchDetails"],
    }),
    editPunchOutTime: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/punch/edit/punch-out",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["PunchDetails"],
    }),
    createRescheduleUpdatedForAllDate: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/emp/schedule/record/for-all",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Reschedule"],
    }),
    getEmpScheduleDetailsByDateRange: builder.query<
      IApiResponse,
      IPayrollPayloadWeeklyReport
    >({
      query: (request) => {
        return {
          url: "/employee/schedule/date/range",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["EmployeeSchedule", "PunchDetails"],
      keepUnusedDataFor: 0,
    }),
    createfixedPayrollGenerate: builder.mutation<
      IApiPayrollGenerateResponse,
      Object
    >({
      query: (request) => {
        return {
          url: "/punch/record/payroll-generate",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Payroll"],
    }),
    getEmployeePayRollAdminUseEdit: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/edit/payroll",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Payroll"],
    }),
    getDashboardFristSection: builder.query<IApiResponseDhashboard, void>({
      query: (request) => {
        return {
          url: "/dashboard/frist/section/getAll",
          method: "POST",
          body: request,
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["dashboard"],
    }),
    getDashboardSecSection: builder.query<IApiResponseDhashboard, void>({
      query: (request) => {
        return {
          url: "/dashboard/sec/section/getAll",
          method: "POST",
          body: request,
        };
      },
      keepUnusedDataFor: 1,
      providesTags: ["dashboard"],
    }),
    getUserInfoOny: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/user/getAll/info",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["User"],
      keepUnusedDataFor: 0,
    }),
    getRestaurant: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/branch/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["branch"],
      keepUnusedDataFor: 0,
    }),
    createRestaurant: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/branch",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["branch"],
    }),
    deleteRestaurant: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/branch/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["branch"],
    }),
    deleteRestaurantSchedule: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/branch/schedule/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["branch"],
    }),
    GetAllUserPrivileges: builder.query<PrivilegesResponse, void>({
      query: (request) => {
        return {
          url: "/privilege/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["User"],
      keepUnusedDataFor: 0,
    }),
    createUser: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["User"],
    }),
    getUserAdminOny: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/user/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["User"],
      keepUnusedDataFor: 0,
    }),
    deleteUser: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/user/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["User"],
    }),
    changeUserPassword: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user/change-password",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["User"],
    }),
    updateUserPrivileges: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user/update-privileges",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["User"],
    }),
    createUserRole: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user/role",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["UserRole", "User"],
    }),
    deleteUserRole: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/user/role/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["UserRole", "User"],
    }),
    getUserRole: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/user/role/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["UserRole", "User"],
      keepUnusedDataFor: 0,
    }),
    createLightThemeColor: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/light/theme/color",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["themeColor"],
    }),
    getAllLightThemeColor: builder.query<
      IApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/light/theme/color/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["themeColor"],
      keepUnusedDataFor: 0,
    }),
    createDarkThemeColor: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/dark/theme/color",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["themeColor"],
    }),
    getAllDarkThemeColor: builder.query<IApiResponse, ILoopingTableListPayload>(
      {
        query: (request) => {
          return {
            url: "/dark/theme/color/getAll",
            method: "POST",
            body: request,
          };
        },
        providesTags: ["themeColor"],
        keepUnusedDataFor: 0,
      }
    ),
    getSetting: builder.query<IApiResponse, ITenatListPayload>({
      query: (request) => {
        return {
          url: "/setting/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Setting"],
      keepUnusedDataFor: 0,
    }),
    createSetting: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/setting",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Setting"],
    }),
    createUserPrivilege: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/user/privilege",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Privilege", "UserRole", "User"],
    }),
    deleteUserPrivilege: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/user/privilege/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Privilege", "UserRole", "User"],
    }),
    getUserPrivilege: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/user/privilege/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Privilege", "UserRole", "User"],
      keepUnusedDataFor: 0,
    }),
    createMeeting: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/meeting",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Meeting", "customer"],
    }),
    getMeeting: builder.query<IApiResponse, IMeetingPayload>({
      query: (request) => {
        return {
          url: "/meeting/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Meeting", "customer"],
      keepUnusedDataFor: 0,
    }),
    deleteMeeting: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/meeting/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Meeting"],
    }),
    getAllPolicyFilter: builder.query<IApiResponse, IPolicyFilterAllPayload>({
      query: (request) => {
        return {
          url: "/policy/filter/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "PolicySummaryReport"],
      keepUnusedDataFor: 0,
    }),
    doneMeeting: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/meeting/done/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Meeting"],
    }),
    getAllMeetingSubject: builder.query<
      IMeetingApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/meeting/subject/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Meeting", "customer"],
      keepUnusedDataFor: 0,
    }),
    connectionRelationShip: builder.query<IApiResponse, IRelationPayload>({
      query: (request) => {
        return {
          url: "/policy/getAll/rconnection/customerId",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer"],
      keepUnusedDataFor: 0,
    }),
    createConversations: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/conversations",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Conversations", "customer"],
    }),
    getConversations: builder.query<IApiResponse, IMeetingPayload2>({
      query: (request) => {
        return {
          url: "/conversations/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Conversations", "customer"],
      keepUnusedDataFor: 0,
    }),
    deleteConversations: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/conversations/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Conversations"],
    }),
    doneConversations: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/conversations/done/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Conversations"],
    }),
    getAllConversationsSubject: builder.query<
      IMeetingApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/conversations/subject/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Conversations", "customer"],
      keepUnusedDataFor: 0,
    }),
    getConversationsHistories: builder.query<IApiResponse, IMeetingPayload2>({
      query: (request) => {
        return {
          url: "/conversations/history/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Conversations", "customer"],
      keepUnusedDataFor: 0,
    }),
    createConversationsMessages: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/conversations/messages",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Conversations", "customer"],
    }),
    getConversationsMessages: builder.query<IApiResponse, IIdOnlyPayload>({
      query: (request) => {
        return {
          url: "/conversations/messages/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Conversations", "customer"],
      keepUnusedDataFor: 0,
    }),
    deleteConversationsMessages: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/conversations/messages/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Conversations"],
    }),
    conversationsMessagesAsReadRecipt: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/conversations/messages/read/${Id}`,
          method: "POST",
        };
      },
      invalidatesTags: ["Conversations"],
    }),
    conversationsMessagesAsRead: builder.query<IApiResponse, IIdOnlyPayload>({
      query: (request) => {
        return {
          url: "/conversations/messages/read",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Conversations", "customer"],
      keepUnusedDataFor: 0,
    }),
    getConversationsNotification: builder.query<IApiResponse, IMeetingPayload2>(
      {
        query: (request) => {
          return {
            url: "/conversations/notification/getAll",
            method: "POST",
            body: request,
          };
        },
        providesTags: ["Conversations", "customer"],
        keepUnusedDataFor: 0,
      }
    ),
    createCustomerRelationShip: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/policy-summary/relations/update",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["customer"],
    }),
    getCustomerWithRelation: builder.query<IApiResponse, IRelationPayload>({
      query: (request) => {
        return {
          url: "/policy-summary/with-relations",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy"],
      keepUnusedDataFor: 0,
    }),
    deleteRelationShip: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/relationship/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["customer", "Policy"],
    }),
    getAllCustomerRelation: builder.query<IApiResponse, IRelationPayload>({
      query: (request) => {
        return {
          url: "/getAll/policy-summary/relations",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy"],
      keepUnusedDataFor: 0,
    }),
    getAllDhashboardFrist: builder.query<
      IApiResponseDhashbordClient,
      IIdOnlyPayload
    >({
      query: (request) => {
        return {
          url: "/dhashboard",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy"],
      keepUnusedDataFor: 0,
    }),
    getAllDhashboardPolicyGroupBy: builder.query<IApiResponse, IPolicyPayload>({
      query: (request) => {
        return {
          url: "/dhashboard/policy/number/group-by/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer"],
      keepUnusedDataFor: 0,
    }),
    getMeetingWithoutDate: builder.query<IApiResponse, IMeetingPayload>({
      query: (request) => {
        return {
          url: "/meeting/getAll/without/Date",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Meeting", "customer"],
      keepUnusedDataFor: 0,
    }),
    createMeetingCategory: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/meeting/category",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Meeting", "customer"],
    }),
    getMeetingCategory: builder.query<IApiResponse, IsearchTextPayload>({
      query: (request) => {
        return {
          url: "/meeting/category/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Meeting", "customer"],
      keepUnusedDataFor: 0,
    }),
    deleteMeetingCategory: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/meeting/category/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Meeting"],
    }),
    createMeetingHoliday: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/meeting/holiday",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Meeting", "customer"],
    }),
    getMeetingHoliday: builder.query<IApiResponse, IsearchTextPayload>({
      query: (request) => {
        return {
          url: "/meeting/holiday/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Meeting", "customer"],
      keepUnusedDataFor: 0,
    }),
    deleteMeetingHoliday: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/meeting/holiday/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Meeting"],
    }),
    getAllHolydaysArray: builder.query<
      IHolidayApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/meeting/holiday/all",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy", "Meeting"],
      keepUnusedDataFor: 0,
    }),
    getMeetingHistoryRecord: builder.query<IApiResponse, IMeetingPayload>({
      query: (request) => {
        return {
          url: "/meeting/history/records/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Meeting", "customer"],
      keepUnusedDataFor: 0,
    }),
    createMeetingNote: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/meeting/note",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Meeting", "customer"],
    }),
    getConversationsDhashNotification: builder.query<
      IApiResponse,
      IMeetingPayload2
    >({
      query: (request) => {
        return {
          url: "/conversations/notification/dhashboard/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Conversations", "customer", "dashboard"],
      keepUnusedDataFor: 0,
    }),
    getAllHolydaysTitle: builder.query<
      IHolidayTitleApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/meeting/holiday/title",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy", "Meeting"],
      keepUnusedDataFor: 0,
    }),
    getAllPolicyGroupByCount: builder.query<ICountApiResponse, IPolicyPayload>({
      query: (request) => {
        return {
          url: "/policy/number/group-by/count",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer"],
      keepUnusedDataFor: 0,
    }),
    getAllByPolicyNumberCount: builder.query<
      IApiResponse,
      IPolicyNumberPayload
    >({
      query: (request) => {
        return {
          url: "/policy/number/count",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer", "PolicyView"],
      keepUnusedDataFor: 0,
    }),
    deletePolicyFristIndex: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/policy/frist/index/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Policy"],
    }),
    createEmail: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/email",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email"],
    }),
    deleteEmail: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/email/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email"],
    }),
    getEmail: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/email/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email"],
      keepUnusedDataFor: 0,
    }),
    createEmailTemplates: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/email/templates",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email"],
    }),
    deleteEmailTemplates: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/email/templates/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email"],
    }),
    getEmailTemplates: builder.query<IApiResponse, ISearchPayload>({
      query: (request) => {
        return {
          url: "/email/templates/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email"],
      keepUnusedDataFor: 0,
    }),
    createEmailRecord: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/email/record",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email", "team"],
    }),
    deleteEmailRecord: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/email/record/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "team"],
    }),
    getEmailRecord: builder.query<IApiResponse, IEmailRecordPayload>({
      query: (request) => {
        return {
          url: "/email/record/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email", "team"],
      keepUnusedDataFor: 0,
    }),
    createClintEmailRecord: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/email/client/record",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email", "customer"],
    }),
    getNewletter: builder.query<IApiResponse, ISearchIsActivePayload>({
      query: (request) => {
        return {
          url: "/newsletter/subscribe/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["newsletter"],
      keepUnusedDataFor: 0,
    }),
    deleteNewletter: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/newsletter/unsubscribe/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "newsletter"],
    }),
    createNewletter: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/newsletter/subscribe",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email", "newsletter"],
    }),
    createNewsletterEmailRecord: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/newsletter/email/record/create",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email", "newsletter"],
    }),
    getNewsletterEmailRecord: builder.query<
      IApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/newsletter/email/record/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email", "newsletter"],
      keepUnusedDataFor: 0,
    }),
    createClientType: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/client_type",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["client_type"],
    }),
    deleteClientType: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/client_type/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["client_type"],
    }),
    getClientType: builder.query<IApiResponse, ILoopingTableListPayload>({
      query: (request) => {
        return {
          url: "/client_type/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["client_type", "category"],
      keepUnusedDataFor: 0,
    }),
    getCustomerNewsLetter: builder.query<
      IApiResponse,
      INewletterCutomerFilterPayload
    >({
      query: (request) => {
        return {
          url: "/newsletters/customer/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy", "newsletter"],
      keepUnusedDataFor: 0,
    }),
    createNewsletterEmailClient: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/newsletter/email/client/create",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email", "newsletter"],
    }),
    // createNewsletterEmailClient: builder.mutation<IApiResponse, FormData>({
    //   query: (formData) => ({
    //     url: "/newsletter/email/client/create",
    //     method: "POST",
    //     body: formData,
    //   }),
    //   invalidatesTags: ["email", "newsletter"],
    // }),
    createNewsletterSmsClient: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/newsletter/sms/client/create",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email", "newsletter"],
    }),
    getAllClientNewsLetter: builder.query<
      IApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/newsletter/email/client/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email", "newsletter"],
      keepUnusedDataFor: 0,
    }),
    resentEmailNewletter: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/newsletter/email/client/resent/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "newsletter"],
    }),
    getAllClientNewsLetterSms: builder.query<
      IApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/newsletter/sms/client/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email", "newsletter"],
      keepUnusedDataFor: 0,
    }),
    resentEmailNewletterSms: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/newsletter/sms/client/resent/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "newsletter"],
    }),
    getCustomerFilterByPerentTable: builder.query<
      IApiResponse,
      IPerentFilterTablePayload
    >({
      query: (request) => {
        return {
          url: "/customer/getAll/filter/table/perent",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy"],
      keepUnusedDataFor: 0,
    }),
    createPolicyCoverage: builder.mutation<IApiLoopingResponse, Object>({
      query: (request) => {
        return {
          url: "/policy/coverage",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Policy", "customer"],
    }),
    getAllPolicyGroupByHistory: builder.query<IApiResponse, IPolicyPayload>({
      query: (request) => {
        return {
          url: "/history/policy",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer"],
      keepUnusedDataFor: 0,
    }),
    getAllByCoverageHistory: builder.query<IApiResponse, IPolicyNumberPayload>({
      query: (request) => {
        return {
          url: "/history/coverage",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer", "PolicyView"],
      keepUnusedDataFor: 0,
    }),
    deleteSmsRecord: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/sms/record/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "team"],
    }),
    getSmsRecord: builder.query<IApiResponse, IEmailRecordPayload>({
      query: (request) => {
        return {
          url: "/sms/record/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["email", "team"],
      keepUnusedDataFor: 0,
    }),
    createClintSmsRecord: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/sms/client/record",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email", "customer"],
    }),
    createStaffSmsRecord: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/sms/staff/record",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["email", "customer"],
    }),
    resentSmsClient: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/sms/client/resent/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "customer"],
    }),
    resentSmsStaff: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/sms/staff/resent/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "team"],
    }),
    resentEmailClient: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/email/client/resent/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "customer"],
    }),
    resentEmailStaff: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/email/staff/resent/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["email", "team"],
    }),
    createTaskCategory: builder.mutation<IApiResponse, Object>({
      query: (request) => {
        return {
          url: "/task/category",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Task", "customer"],
    }),
    getTaskCategory: builder.query<IApiResponse, IsearchTextPayload>({
      query: (request) => {
        return {
          url: "/task/category/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Task", "customer"],
      keepUnusedDataFor: 0,
    }),
    deleteTaskCategory: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/task/category/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Task"],
    }),
    createTask: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/task",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Task", "customer"],
    }),
    getTask: builder.query<IApiResponse, IMeetingPayload>({
      query: (request) => {
        return {
          url: "/task/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Task", "customer"],
      keepUnusedDataFor: 0,
    }),
    deleteTask: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/task/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Task"],
    }),
    doneTask: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/task/done/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Meeting"],
    }),
    getAllTaskSubject: builder.query<
      IMeetingApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/task/subject/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Task", "customer"],
      keepUnusedDataFor: 0,
    }),
    getTaskWithoutDate: builder.query<IApiResponse, ITasksPayload>({
      query: (request) => {
        return {
          url: "/task/getAll/without/Date",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Task", "customer"],
      keepUnusedDataFor: 0,
    }),
    createTaskNote: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/task/note",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Task", "customer"],
    }),
    getTaskHistoryRecord: builder.query<IApiResponse, IMeetingPayload>({
      query: (request) => {
        return {
          url: "/task/history/records/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Task", "customer"],
      keepUnusedDataFor: 0,
    }),
    getlastUpdateRemark: builder.query<
      ILastUpdateSummaryApiResponse,
      IgetLastUpdatedRemarkPayload
    >({
      query: (request) => {
        return {
          url: "/policy-summary/get/last/remark",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["PolicySummaryReport"],
      keepUnusedDataFor: 0,
    }),
    getAllWorkshop: builder.query<IApiResponse, ITasksPayload>({
      query: (request) => {
        return {
          url: "/workshop/registrations/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Workshop"],
      keepUnusedDataFor: 0,
    }),
    createWorkshop: builder.mutation<IApiCustomerResponse, Object>({
      query: (request) => {
        return {
          url: "/workshop/registrations",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Workshop"],
    }),
    deleteWorkshopRegistrations: builder.mutation<
      IApiResponseDelateClient,
      string
    >({
      query: (Id) => {
        return {
          url: `/workshop/registrations/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Workshop"],
    }),
    getWorkshopHistoryRecord: builder.query<IApiResponse, IMeetingPayload>({
      query: (request) => {
        return {
          url: "/workshop/registrations/history",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Workshop"],
      keepUnusedDataFor: 0,
    }),
    createNewsletterEmailWorkshops: builder.mutation<
      IApiLoopingResponse,
      Object
    >({
      query: (request) => {
        return {
          url: "/newsletter/email/workshop/create",
          method: "POST",
          body: JSON.stringify(request),
        };
      },
      invalidatesTags: ["Workshop"],
    }),
    getAllWorkshopNewsLetter: builder.query<
      IApiResponse,
      ILoopingTableListPayload
    >({
      query: (request) => {
        return {
          url: "/newsletter/email/workshop/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Workshop"],
      keepUnusedDataFor: 0,
    }),
    resentWorkshopEmailNewletter: builder.mutation<IApiResponse, string>({
      query: (Id) => {
        return {
          url: `/newsletter/email/workshop/resent/${Id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Workshop"],
    }),
    getMultiCustomerSummaryReport: builder.query<
      IApiResponse,
      IMultiClientSummayReport
    >({
      query: (request) => {
        return {
          url: "/policy/summary/muiltiple/report",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy"],
      keepUnusedDataFor: 0,
    }),
    getAllWorkshopFeedbacks: builder.query<IApiResponse, ITasksPayload>({
      query: (request) => {
        return {
          url: "/workshop/feedbacks/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Workshop"],
      keepUnusedDataFor: 0,
    }),
    downloadMultipleReports: builder.mutation<
      DownloadPdfResponse,
      { ids: string[] }
    >({
      query: (body) => ({
        url: "policy/summary/muiltiple/report",
        method: "POST",
        body,
      }),
    }),
    getCustomerPolicyReport: builder.query<IApiResponse, IRelationPayload>({
      query: (request) => {
        return {
          url: "/policy/summary/muiltiple/report/getAll",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["customer", "Policy"],
      keepUnusedDataFor: 0,
    }),
    getAllPolicyGropBy: builder.query<IApiResponse, IPolicyPayload>({
      query: (request) => {
        return {
          url: "/policy/getAll/group-by",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["Policy", "customer"],
      keepUnusedDataFor: 0,
    }),
    getAllBirthdayDhashboard: builder.query<
      IApiBirthdayResponse,
      IPolicyPayload
    >({
      query: (request) => {
        return {
          url: "/dashboard/birthdays",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["dashboard"],
      keepUnusedDataFor: 0,
    }),
    getAllInsuranceCompanyDhashboard: builder.query<
      IApiResponse,
      ISumaryReportListPayload
    >({
      query: (request) => {
        return {
          url: "/dashboard/insurance-comapny",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["dashboard"],
      keepUnusedDataFor: 0,
    }),
    getAllTypeOfCoveraegeDhashboard: builder.query<
      IApiResponse,
      ISumaryReportListPayload
    >({
      query: (request) => {
        return {
          url: "/dashboard/type-of-coverage",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["dashboard"],
      keepUnusedDataFor: 0,
    }),
    getClientTypeBarChart: builder.query<
      IApiResponse,
      IPerentFilterTablePayload
    >({
      query: (request) => {
        return {
          url: "/dashboard/client-type",
          method: "POST",
          body: request,
        };
      },
      providesTags: ["dashboard"],
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useGetUserQuery,
  useLoginMutation,
  useCreateCategoryMutation,
  useCreateCompanyMutation,
  useCreateDepartmentMutation,
  useCreateCoursingMutation,
  useCreateTaxMutation,
  useGetDepartmentQuery,
  useCreateProductBrandMutation,
  useCreateProductTagMutation,
  useCreateProductCategoryMutation,
  useCreateProductMutation,
  useCreatePrinterMutation,
  useGetCategoryQuery,
  useGetAllMainCategoryQuery,
  useDeleteCoursingMutation,
  useDeleteDepartmentMutation,
  useDeletePrinterMutation,
  useDeleteProductBrandMutation,
  useDeleteProductTagMutation,
  useDeleteTaxMutation,
  useDeleteProductCategoryMutation,
  useDeleteCategoryMutation,
  useGetProductQuery,
  useCreateGetAllProductMutation,
  useDeleteProductMutation,
  useGetLastProductIdQuery,
  useCreateModifierMutation,
  useGetAllModifierQuery,
  useDeleteModifierMutation,
  useGetTaxQuery,
  useGetCoursingQuery,
  useGetPrinterQuery,
  useGetProductTagQuery,
  useGetProductBrandQuery,
  useGetProductCategoryQuery,
  useGetSubCategoryByCategoryIdQuery,
  useGetSubCategoryByArrayQuery,
  useGetProductSubCategoryQuery,
  useGetAllCategoryNameQuery,
  useGetCtegoryFilterQuery,
  useGetLoopingTableQuery,
  useCreateLoopingTableMutation,
  useGetAllLoopingTableQuery,
  useDeleteLoopingTableMutation,
  useUpdateLoopingTableMutation,
  useInsertOrUpdateDataLoopingTableMutation,
  useGetCustomerQuery,
  useDeleteCustomerMutation,
  useCreateCustomerMutation,
  useGetCustomerTransactionQuery,
  useDeleteCustomerTransactionMutation,
  useCreateCustomerTransactionMutation,
  useDeleteCompanyMutation,
  useGetCompanyQuery,
  useGetAllSearchCompanyQuery,
  useCreateThemeColorMutation,
  useGetAllThemeColorQuery,
  useCreatePolicyMutation,
  useGetAllPolicyQuery,
  useGetLimitOneCustomerQuery,
  useGetAllPolicyTermsQuery,
  useCreatePolicyTermsMutation,
  useGetAllPolicyCustomerIdQuery,
  useCreatePolicySummaryReportMutation,
  useCreatePolicySummaryDescriptionMutation,
  useCreatePolicySummaryRemarkMutation,
  useGetAllByPolicyNumberQuery,
  useGetAllPolicyGroupByQuery,
  useGetAllPolicyGroupByEmptyQuery,
  useCreateSumaryReportPolicyTermsMutation,
  useCreateCoveragePolicyTermsContionMutation,
  useCreateOfficeUseMutation,
  useDeletePolicyTermsMutation,
  useGetFinalSummaryReportQuery,
  useDeleteBasicsPolicyMutation,
  useCreatePolicyBasicsMutation,
  useDeletePolicyMutation,
  useGetCustomerFilterByPerentQuery,
  useGetCustomerRelationQuery,

  useCreateLightThemeColorOderMutation,
  useCreateDarkThemeColorOrderMutation,

  useCreateTeamMutation,
  useDeleteTeamMutation,
  useGetTeamQuery,
  useGetPunchDetailsQuery,
  useGetPunchDashboardQuery,
  useDeleteEmployeeScheduleMutation,
  useGetEmployeeScheduleDetailsQuery,
  useGetEmployeeScheduleDetailsByDateQuery,
  useGetEmployeeImgQuery,
  useCreatePositionMutation,
  useDeletePositionMutation,
  useGetPositionQuery,
  useGetEmployeePayRollQuery,
  useCreateAdminEditPunchMutation,
  useGetEmployeePayRollAdminQuery,
  useGetlastUpdateDatePayrollQuery,
  useCreateRescheduleMutation,
  useDeleteRescheduleMutation,
  useGetRescheduleQuery,
  useGetTeamSerchOnlyQuery,
  useGetEmployeeScheduleDetailsByDateOnlyQuery,
  useRemovedRescheduleMutation,
  useGetRescheduleOrderByDateQuery,
  useGetEmployeePayRollAdminUseMutation,
  useGetAnEmployeePayRollAdminQuery,
  useGetAllPayrollListQuery,
  useGetAllPayrollRecordeDateRangeQuery,
  useGetSaveEmployeePayrollRecordQuery,
  useGetSaveAnEmployeePayRollAdminQuery,
  useGetSaveAnEmplEachRecordPayRollAdminQuery,
  useGetPunchDetailsEmpQuery,
  useGetSaveEmployeePayrollAnEmployeeRecordQuery,
  usePayrollRecordeEmpQuery,
  useEditEmployeePayRollAdminQuery,
  useGetDayRecordAnEmplEachRecordQuery,
  useEmpPayrollPayrollRecordReportQuery,
  useEditPunchInTimeMutation,
  useEditPunchOutTimeMutation,
  useCreateRescheduleUpdatedForAllDateMutation,
  useGetEmpScheduleDetailsByDateRangeQuery,
  useCreatefixedPayrollGenerateMutation,
  useGetEmployeePayRollAdminUseEditMutation,
  useGetDashboardFristSectionQuery,
  useGetDashboardSecSectionQuery,
  useGetUserInfoOnyQuery,
  useGetRestaurantQuery,
  useCreateRestaurantMutation,
  useDeleteRestaurantMutation,
  useDeleteRestaurantScheduleMutation,
  useGetAllUserPrivilegesQuery,
  useCreateUserMutation,
  useGetUserAdminOnyQuery,
  useDeleteUserMutation,
  useChangeUserPasswordMutation,
  useUpdateUserPrivilegesMutation,
  useCreateUserRoleMutation,
  useDeleteUserRoleMutation,
  useGetUserRoleQuery,
  useCreateDarkThemeColorMutation,
  useCreateLightThemeColorMutation,
  useGetAllDarkThemeColorQuery,
  useGetAllLightThemeColorQuery,
  useCreateSettingMutation,
  useGetSettingQuery,
  useCreateUserPrivilegeMutation,
  useGetUserPrivilegeQuery,
  useDeleteUserPrivilegeMutation,
  useGetMeetingQuery,
  useCreateMeetingMutation,
  useDeleteMeetingMutation,
  useGetAllPolicyFilterQuery,
  useDoneMeetingMutation,
  useGetAllMeetingSubjectQuery,
  useConnectionRelationShipQuery,
  useCreateConversationsMutation,
  useDeleteConversationsMutation,
  useGetConversationsQuery,
  useDoneConversationsMutation,
  useGetAllConversationsSubjectQuery,
  useGetConversationsHistoriesQuery,
  useCreateConversationsMessagesMutation,
  useDeleteConversationsMessagesMutation,
  useGetConversationsMessagesQuery,
  useConversationsMessagesAsReadQuery,
  useConversationsMessagesAsReadReciptMutation,
  useGetConversationsNotificationQuery,
  useCreateCustomerRelationShipMutation,
  useGetCustomerWithRelationQuery,
  useDeleteRelationShipMutation,
  useGetAllCustomerRelationQuery,
  useGetAllDhashboardFristQuery,
  useGetAllDhashboardPolicyGroupByQuery,
  useGetMeetingWithoutDateQuery,
  useGetMeetingCategoryQuery,
  useGetMeetingHolidayQuery,
  useCreateMeetingCategoryMutation,
  useCreateMeetingHolidayMutation,
  useDeleteMeetingCategoryMutation,
  useDeleteMeetingHolidayMutation,
  useGetAllHolydaysArrayQuery,
  useGetMeetingHistoryRecordQuery,
  useCreateMeetingNoteMutation,
  useGetConversationsDhashNotificationQuery,
  useGetAllHolydaysTitleQuery,
  useGetAllPolicyGroupByCountQuery,
  useGetAllByPolicyNumberCountQuery,
  useDeletePolicyFristIndexMutation,
  useCreateEmailMutation,
  useGetEmailQuery,
  useDeleteEmailMutation,
  useCreateEmailTemplatesMutation,
  useGetEmailTemplatesQuery,
  useDeleteEmailTemplatesMutation,
  useCreateEmailRecordMutation,
  useDeleteEmailRecordMutation,
  useGetEmailRecordQuery,
  useCreateClintEmailRecordMutation,
  useCreateNewletterMutation,
  useDeleteNewletterMutation,
  useGetNewletterQuery,
  useCreateNewsletterEmailRecordMutation,
  useGetNewsletterEmailRecordQuery,
  useGetClientTypeQuery,
  useCreateClientTypeMutation,
  useDeleteClientTypeMutation,
  useGetCustomerNewsLetterQuery,
  useCreateNewsletterEmailClientMutation,
  useCreateNewsletterSmsClientMutation,
  useGetAllClientNewsLetterQuery,
  useResentEmailNewletterMutation,
  useGetAllClientNewsLetterSmsQuery,
  useResentEmailNewletterSmsMutation,
  useGetCustomerFilterByPerentTableQuery,
  useCreatePolicyCoverageMutation,
  useGetAllPolicyGroupByHistoryQuery,
  useGetAllByCoverageHistoryQuery,
  useGetSmsRecordQuery,
  useCreateClintSmsRecordMutation,
  useDeleteSmsRecordMutation,
  useResentSmsClientMutation,
  useResentSmsStaffMutation,
  useResentEmailClientMutation,
  useResentEmailStaffMutation,
  useCreateStaffSmsRecordMutation,
  useCreateTaskCategoryMutation,
  useGetTaskCategoryQuery,
  useDeleteTaskCategoryMutation,
  useCreateTaskMutation,
  useGetTaskQuery,
  useDeleteTaskMutation,
  useDoneTaskMutation,
  useGetAllTaskSubjectQuery,
  useGetTaskWithoutDateQuery,
  useCreateTaskNoteMutation,
  useGetTaskHistoryRecordQuery,
  useGetlastUpdateRemarkQuery,
  useGetAllWorkshopQuery,
  useCreateWorkshopMutation,
  useDeleteWorkshopRegistrationsMutation,
  useGetWorkshopHistoryRecordQuery,
  useCreateNewsletterEmailWorkshopsMutation,
  useGetAllWorkshopNewsLetterQuery,
  useResentWorkshopEmailNewletterMutation,
  useGetMultiCustomerSummaryReportQuery,
  useGetAllWorkshopFeedbacksQuery,
  useDownloadMultipleReportsMutation,
  useGetCustomerPolicyReportQuery,
  useGetAllPolicyGropByQuery,
  useGetAllBirthdayDhashboardQuery,
  useGetAllInsuranceCompanyDhashboardQuery,
  useGetAllTypeOfCoveraegeDhashboardQuery,
  useGetClientTypeBarChartQuery
} = attoDeskApi;
